import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card h-100 border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card2 = _resolveComponent("Card2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card border-0", _ctx.widgetClasses]),
    "data-aos": "zoom-in"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card2, {
        "card-classes": "h-100",
        title: "Total Devices",
        icon: "fa-layer-group text-success",
        content: "4237",
        color: "success",
        arrow: "Up-right",
        "footer-data": "+40.5%",
        "footer-text": "This Month"
      })
    ])
  ], 2))
}